module.exports = __webpack_public_path__ + "img/5h.b7814b73.png";